// eslint-disable-next-line prettier/prettier
const Space = () => <>{' '}</>;

export default Space;
